import Pencil from '@mdi/svg/svg/pencil.svg';
import Calculator from '@mdi/svg/svg/calculator.svg';
import CashMultiple from '@mdi/svg/svg/cash-multiple.svg';
import Cellphone from '@mdi/svg/svg/cellphone.svg';


export default [
  {
    link: 'https://cv.pracuj.pl/',
    icon: Pencil,
    title: 'Kreator CV',
    subtitle: 'Stwórz skuteczne CV w\u00A03\u00A0krokach',
    testName: 'tools_cv-creator'
  },
  {
    link: 'https://zarobki.pracuj.pl/kalkulator-wynagrodzen',
    icon: Calculator,
    title: 'Kalkulator wynagrodzeń',
    subtitle: 'Oblicz zarobki netto i brutto na\u00A0różnych umowach',
    testName: 'tools_calculator'
  },
  {
    link: 'https://zarobki-raport.pracuj.pl/#!/survey/step-0',
    icon: CashMultiple,
    title: 'Raport zarobków',
    subtitle: 'Porównaj swoją pensję z\u00A0zarobkami na\u00A0podobnych stanowiskach',
    testName: 'tools_earnings-report'
  },
  {
    link: 'https://go.onelink.me/RbqI/2745c875',
    icon: Cellphone,
    title: 'Pobierz aplikację',
    subtitle: 'Przeglądaj oferty wygodnie, również na mapie',
    testName: 'tools_mobile-app'
  }
];
